/**
 * Font family configuration
 * Primary: IBM Plex Sans and IBM Plex Mono
 * Fallback: Roboto and system default
 */
export const FONT_FAMILIES = {
    primary: '"IBM Plex Sans", "Roboto", sans-serif',
    monospace: '"IBM Plex Mono", "Roboto Mono", monospace',
  };
  
  /**
   * Font weights mapping
   */
  export const FONT_WEIGHTS: { [s: string]: number; } = {
    REGULAR: 400,
    MEDIUM: 500,
    SEMIBOLD: 600,
    BOLD: 700,
  };
  
  /**
   * Font sizes used across the application
   */
  export const FONT_SIZES: { [s: string]: string; } = {
    XS: "0.75rem",
    SM: "0.813rem",
    BASE: "0.875rem", // previously hardcoded in button
    MD: "1rem",
    LG: "1.25rem",
    XL: "1.563rem",
    XXL: "1.938rem",
    XXXL: "2.438rem",
    CUSTOM_938: "0.938rem", // previously hardcoded navRail
  };
  
  /**
   * Line heights used across the application
   */
  export const LINE_HEIGHTS: { [s: string]: number; } = {
    TIGHT: 1.1,
    COMPACT: 1.16,
    SNUG: 1.3,
    RELAXED: 1.375,
    LOOSE: 1.5,
    NAV: 1.33, // for navRail
  };
  
  /**
   * Letter spacing values used across the application
   */
  export const LETTER_SPACING: { [s: string]: string; } = {
    NONE: "0px",
    NEG_SM: "-0.13px",
    NEG_MD: "-0.16px",
    NEG_LG: "-0.25px",
    NEG_XL: "-0.20px",
    POS_SM: "0.08rem",
    POS_LG: "2px",
  };